export function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2;
}

export function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
}

export function linear(t) {
  return t;
}

const easings = { easeInOutQuad, easeInOutCubic, linear };

export function getEasing(name) {
  return easings[name] || easeInOutQuad;
}
